import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../hooks'
import { getDocFlowCreationSuccessNotification } from '../../DocFlow.utils'
import { DocFlowFormModal } from '../../DocFlowFormModal'

export function useCreateDocFlow({ setModal, onClose, onReload, onSubmit }) {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  function handleSuccess(data) {
    onClose()

    handleAddSuccessNotification(
      getDocFlowCreationSuccessNotification({
        data,
        t,
      })
    )

    onReload?.()
  }

  function handleOpenCreation(initialValues) {
    setModal(
      <DocFlowFormModal
        initialValues={initialValues}
        onClose={onClose}
        onSubmit={onSubmit}
        onSuccess={handleSuccess}
      />
    )
  }

  return {
    handleOpenCreation,
  }
}
